module.exports = __webpack_public_path__ + "img/icon_dijia.4aeab1c6.svg";